<template>
  <div class="w-full flex justify-center bg-[#f9f8f6] font-rubik">
    <div class="flex flex-col justify-center contact-us-inner-container">
      <sub-header class="w-full" />
      <div class="w-full flex flex-col 1170-bp:flex-row">
        <find-inventory />

        <div class="w-full">
          <article v-if="lead" class="message is-medium is-primary contact-us-article-container">
            <div class="message-header" style="background-color: #3565FC;">
              <p>Thanks for the inquiry, {{ lead.firstName }}.</p> 
            </div>
            <div class="message-body" style="background-color: #FFFFFF;">
              <p>
                One of our representatives will be in contact shortly.
                If you need immediate service, please call us at {{ phoneNumber }}.
              </p>
            </div>
          </article>
          <p v-else-if="error">
            We are sorry, there was a problem with your request. Error: {{ error }}
          </p>
          <contact-us-form v-else @success="handleSuccess" @error="handleError"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from './helpers/sub-header.vue'
import ContactUsForm from './helpers/contact-us-form.vue'
import FindInventory from './helpers/find-inventory.vue'
import { mapState } from 'vuex'

export default {
  components: {
    SubHeader,
    ContactUsForm,
    FindInventory
  },
  data() {
    return {
      lead: null,
      error: null
    }
  },
  computed: mapState('shared', ['phoneNumber']),
  methods: {
    handleSuccess (lead) {
      this.lead = lead
    },
    handleError (error) {
      this.error = error
    }
  }
}
</script>

<style scoped>
  .contact-us-inner-container {
    width: 100%;
    max-width: 1440px;
    margin-bottom: 112px;
  }


  /* smaller screens */
  @media(max-width: 1440px) {
    .contact-us-inner-container {
      max-width: 1216px;
    }
  }

  /* Mobile Styles */
  @media (max-width: 1170px) {
    .contact-us-article-container {
      padding: 20px;
    }
  }
</style>